import React from 'react';

const AccountIcon = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M5.14 15.7075C5.34626 15.021 5.76831 14.4193 6.34354 13.9916C6.91877 13.564 7.61654 13.3331 8.33333 13.3333H11.6667C12.3844 13.3331 13.083 13.5645 13.6587 13.9932C14.2343 14.4218 14.6562 15.0248 14.8617 15.7125M2.5 10C2.5 10.9849 2.69399 11.9602 3.0709 12.8701C3.44781 13.7801 4.00026 14.6069 4.6967 15.3033C5.39314 15.9997 6.21993 16.5522 7.12987 16.9291C8.03982 17.306 9.01509 17.5 10 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.7801 16.5522 14.6069 15.9997 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.01509 17.306 8.03982 16.9291 7.12987C16.5522 6.21993 15.9997 5.39314 15.3033 4.6967C14.6069 4.00026 13.7801 3.44781 12.8701 3.0709C11.9602 2.69399 10.9849 2.5 10 2.5C9.01509 2.5 8.03982 2.69399 7.12987 3.0709C6.21993 3.44781 5.39314 4.00026 4.6967 4.6967C4.00026 5.39314 3.44781 6.21993 3.0709 7.12987C2.69399 8.03982 2.5 9.01509 2.5 10ZM7.5 8.33333C7.5 8.99637 7.76339 9.63226 8.23223 10.1011C8.70107 10.5699 9.33696 10.8333 10 10.8333C10.663 10.8333 11.2989 10.5699 11.7678 10.1011C12.2366 9.63226 12.5 8.99637 12.5 8.33333C12.5 7.67029 12.2366 7.03441 11.7678 6.56557C11.2989 6.09673 10.663 5.83333 10 5.83333C9.33696 5.83333 8.70107 6.09673 8.23223 6.56557C7.76339 7.03441 7.5 7.67029 7.5 8.33333Z",
      stroke: "#FFF",
      strokeWidth: "1.5",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  )
);

export { AccountIcon };
//# sourceMappingURL=AccountIcon.js.map
